import React, { useState } from "react";
import { useAxiosContext } from "../../../../context/AxiosContext";
import { useAuth0Context } from "../../../../context/Auth0Context";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import BuilderModal from "../../../../Layouts/Modal/BuilderModal";
import PageInfoAndActionBar from "../../../../Layouts/PageInfoAndActionBar";
import NotesAndTags from "../../../../components/BuilderComponents/NotesAndTags";
import AccessTemplateSelection from "../../../../components/BuilderComponents/AccessTemplateSelection";
import { toastError } from "../../../../utils/toastUtils";

const MobileRVPageActionsHandler = () => {
  const initialModalState = {
    show: false,
    type: "",
    modalName: ""
  };
  const [isModalOpen, setIsModalOpen] = useState(initialModalState);
  const {
    recordsviewLayout,
    applicationBlockData,
    setApplicationBlockData,
    layout,
    layoutData,
    nestedGridData,
    handleCloneApplicationBlock,
    handleSaveApplicationBlock,
    lockData,
    setLockData
  } = useAppBlocksContext();
  const { user } = useAuth0Context();
  const { axiosInstance, handleSuccess } = useAxiosContext();

  const closeModal = () => {
    setIsModalOpen(initialModalState);
  };

  const openModal = (type, modalName) => {
    setIsModalOpen({ show: true, type, modalName });
  };

  const handletoggleLock = async () => {
    try {
      if (lockData && lockData.user_id) {
        if (lockData.user_id !== user.sub) {
          toastError("Unauthorized");
          return;
        }
        const { message } = await axiosInstance.delete(`/app/lock/${applicationBlockData.id}`);
        handleSuccess(message);
        setLockData({});
      } else {
        const userinfo = `${user.first_name} (${user.email})`;
        const lock = {
          type: "recordview",
          user_id: user.sub,
          user_info: userinfo,
          type_id: applicationBlockData.id,
          type_name: applicationBlockData.name
        };
        const { message } = await axiosInstance.post(`/app/lock`, lock);
        handleSuccess(message);
        setLockData(lock);
      }
    } catch (error) {
      console.error("API call failed", error);
    }
  };

  const openNoteModal = () => {
    openModal("notes", `Edit Notes and Tags`);
  };

  const openAccessTemplateModal = () => {
    openModal("access_template", "Recordview Permissions");
  };

  const handleNotesAndTag = (data, keyName) => {
    const copyBlockData = JSON.parse(JSON.stringify(applicationBlockData));
    copyBlockData[keyName] = data;
    setApplicationBlockData(copyBlockData);
  };

  const handleAccessTemplate = (data) => {
    const newData = JSON.parse(JSON.stringify(applicationBlockData));
    newData.access_templates = data;
    setApplicationBlockData(newData);
    closeModal();
  };

  return (
    <>
      <PageInfoAndActionBar
        pagePath={`Blocks/Recordsview/${applicationBlockData.name}`}
        toggleLock={handletoggleLock}
        currentConfig={[recordsviewLayout, applicationBlockData, layout, layoutData.current, nestedGridData.current]}
        pageName="applicationblock"
        savePage={handleSaveApplicationBlock}
        clonePage={handleCloneApplicationBlock}
        notesPage={openNoteModal}
        saveOwner={openAccessTemplateModal}
        isLocked={lockData?.user_id || null}
      />
      <BuilderModal isOpen={isModalOpen.show} onClose={closeModal} modalName={isModalOpen.modalName}>
        {isModalOpen.type === "notes" && (
          <NotesAndTags
            notesValue={applicationBlockData.description || ""}
            tagValue={applicationBlockData.info_tag || []}
            onChange={handleNotesAndTag}
          />
        )}
        {isModalOpen.type === "access_template" && (
          <AccessTemplateSelection
            templates={applicationBlockData.access_templates}
            handleChange={handleAccessTemplate}
          />
        )}
      </BuilderModal>
    </>
  );
};

export default MobileRVPageActionsHandler;
